import { getAccountByProductType } from '../multiLoanDashboard/accountsSelector';
import { RLS_PRODUCT_TYPE } from './dashboard/dashboardSelectors';

export function hasRLSAccount(state) {
    return Boolean(getAccountByProductType(state, RLS_PRODUCT_TYPE));
}
